import { FC, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Footwear_image_2 from "../../assets/Footwear_image_2.png";
import MeasuredBy from "../molecules/MeasuredBy";

import { findBrandByDomain } from "../../configs/configLoader";
import { activeStylesContinue } from "../../configs";
import { hoverStylesContinue } from "../../configs/stylesLoader";
import { ArrowForward as ChevronRight } from "@mui/icons-material";

import "./index.css";

interface IPropsStepIntroInfoFoot {
  step: any;
  nextStep: () => void;
  descriptionStyles: {
    color: string;
    fontSize: React.CSSProperties["fontSize"];
    fontWeight: number;
    textAlign: React.CSSProperties["textAlign"];
    textTransform: React.CSSProperties["textTransform"];
    justifyContent: React.CSSProperties["justifyContent"];
    fontFamily: string;
    lineHeight: string;
    margin: string;
  };
}

const StepIntroInfoFoot: FC<IPropsStepIntroInfoFoot> = ({
  step,
  nextStep,
  descriptionStyles,
}) => {
  const { t } = useTranslation("components/device_select");

  const [hovered, setHovered] = useState(false);

  const brandDefined = findBrandByDomain();

  const isIntersport = brandDefined?.name === "Intersport";
  const isBlackstore = brandDefined?.name === "Blackstore";

  const isCustomBrands = isIntersport || isBlackstore;

  const mergedButtonStyles: React.CSSProperties = {
    ...(isCustomBrands ? activeStylesContinue : {}),
    ...(isIntersport && hovered ? hoverStylesContinue : {}),
    textTransform:
      descriptionStyles.textTransform as React.CSSProperties["textTransform"],
    marginBottom: "10px",
    position: "relative",
    padding: "16px",
    height: "auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "visible",
  };

  const arrowContainerStyle: React.CSSProperties = {
    display: "inline-block",
    width: hovered ? 16 : 0,
    overflow: "hidden",
    verticalAlign: "middle",
    transition: "width 160ms ease",
  };

  const iconStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    opacity: hovered ? 1 : 0,
    transform: hovered ? "translateX(0)" : "translateX(-6px)",
    transition: "opacity 160ms ease, transform 160ms ease",
    display: "inline-block",
    verticalAlign: "middle",
    pointerEvents: "none",
  };

  return (
    <>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <span className="description" style={descriptionStyles}>
          {t("intro_info_foot.text")}
        </span>

        <Box className="info-container">
          <img
            src={Footwear_image_2}
            alt="Footwear_image_2"
            style={{ borderRadius: "10px" }}
          />
        </Box>

        <Box className="info-text-container">
          <Box className="info-text-gap-container">
            <span className="info-text-container-circle">1</span>
            <span className="info-text-container-text-head">
              {t("intro_info_foot.first_item")}
            </span>
            <span className="info-text-container-text-description">
              {t("intro_info_foot.first_item_desc")}
            </span>
          </Box>

          <div className="divider-2" />

          <Box className="info-text-gap-container">
            <span className="info-text-container-circle">2</span>
            <span className="info-text-container-text-head">
              {t("intro_info_foot.second_item")}
            </span>
            <span className="info-text-container-text-description">
              {t("intro_info_foot.second_item_desc")}
            </span>
          </Box>

          <div className="divider-2" />

          <Box className="info-text-gap-container">
            <span className="info-text-container-circle">3</span>
            <span className="info-text-container-text-head">
              {t("intro_info_foot.third_item")}
            </span>
            <span className="info-text-container-text-description">
              {t("intro_info_foot.third_item_desc")}
            </span>
          </Box>
        </Box>

        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "30px",
          }}
        >
          <span
            style={{
              width: "100%",
              height: "4px",
              background: "#2E2E2E",
              borderRadius: "7px",
            }}
          />
          <span
            style={{
              width: "100%",
              height: "4px",
              background: "#2E2E2E",
              borderRadius: "7px",
            }}
          />
        </Box>

        <button
          type="button"
          className="continue-button"
          onClick={() => {
            nextStep();
          }}
          style={mergedButtonStyles}
          onMouseEnter={() => {
            setHovered(true);
          }}
          onMouseLeave={() => {
            setHovered(false);
          }}
        >
          <div style={{ display: "inline-flex", alignItems: "center", gap: 0 }}>
            {t("intro_info_foot.continue")}

            {isIntersport && (
              <span style={arrowContainerStyle} aria-hidden>
                <ChevronRight style={iconStyle} />
              </span>
            )}
          </div>
        </button>
      </Box>
      <MeasuredBy step={step} />
    </>
  );
};

export default StepIntroInfoFoot;
